import React from 'react'

const auditInfoContext = React.createContext();

function auditInfoReducer(state, action) {
  switch (action.type) {
    case 'updateURL':
      return {...state, urls: action.payload.urls};
    case 'updateGraphics':
      return {...state, graphics: action.payload.graphics};
    case 'updateImg':
      return {...state, imgData: action.payload.imgData};
    default:
      return state
  }
}

// function Counter() {
//   const [state, dispatch] = useReducer(reducer, initialState);

export { auditInfoReducer, auditInfoContext }
